import { gql } from 'apollo-angular';
import { notificationItemFragment } from './notification.fragments';

export const CreateReminderNotificationMutation = gql`
  mutation CreateReminderNotificationMutation($input: CreateReminderNotificationInput!) {
    createReminderNotification(input: $input) {
      errors {
        message
        path
      }
      notification {
        ...NotificationItem
      }
    }
  }
  ${notificationItemFragment}
`;

export const batchRemoveAllNotificationsSnippet = `
    destroyNotification(input: $destroyNotificationInput) {
    
      errors {
        message
        path
      } 
      
      notification {
        id
      }
    }
`;
